import PropTypes from "prop-types";
import "./raikoToggleOutlinedStyleSheet.scss"

const RaikoToggleOutlined = (
    {
        checked,
        setChecked,
        labelText,
        className
    }) => {

    return (
        <label className={`checkboxContainer ${className}`}>
            <span>{labelText}</span>
            <label className="checkboxSwitch" htmlFor="status">
                <input
                    type="checkbox"
                    id="status"
                    checked={checked}
                    onChange={e => {
                        setChecked(e.target.checked)
                    }}
                />
                <span className="toggle round"/>
            </label>

        </label>
    )
}

RaikoToggleOutlined.propTypes = {
    checked: PropTypes.bool.isRequired,
    setChecked: PropTypes.func.isRequired,
    labelText: PropTypes.string.isRequired,
}


export default RaikoToggleOutlined